import {Component, ViewChild} from '@angular/core';
import {DatatableViewComponent} from '@ngx-ivengi/crud';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {Price} from './price.model';
import {PriceService} from './price.service';
import {UIRouter} from '@uirouter/angular';

@Component({
  selector: 'app-price-overview',
  templateUrl: './price-overview.component.html'
})
export class PriceOverviewComponent extends DatatableViewComponent<Price> {

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  constructor(
    private priceService: PriceService,
    private router: UIRouter
  ) {
    super(priceService);

    this.fetchData();
  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.priceService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }

  public onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go('file', { fileId: event.row.fileId }, { reload: true });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/price/price-overview.component.ts